module.exports = __webpack_public_path__ + "static/img/master.f997432.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dashboard/league-ad-section/master.png
// module id = CmKu
// module chunks = 35